export const POST_ADMIN_USER_LOGIN = "POST_ADMIN_USER_LOGIN";
export const POST_ADMIN_USER_LOGIN_SUCCESS = "POST_ADMIN_USER_LOGIN_SUCCESS";
export const POST_ADMIN_USER_LOGIN_ERROR = "POST_ADMIN_USER_LOGIN_ERROR";
